import React, { useContext, useEffect, useState } from "react";
import { Formik } from "formik";
import { Form as FormikForm } from "formik";
import * as Yup from "yup";
import { Box, Button, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import MusicVideoIcon from "@mui/icons-material/MusicVideo";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Files from "react-files";
import { ContainerModal } from "../../pages/MyTracks/styles";
import { styles } from "../../pages/MyTracks/styles";
import { BatchTrackAddModalProps } from "../../pages/MyTracks/types";
import { awaitableUploadToS3 } from "../../utils/S3Utils";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { LightTooltip } from "../LightToolTip/LightToolTip";
import { S3CredentialsContextInterface } from "../../contexts";
import { S3CredentialsContext } from "../../contexts";
import { AuthContext, AuthContextInterface } from "../../contexts";
import { UserDetailsContext } from "../../contexts";
import { UserDetailsContextInterface } from "../../contexts";
import {
  Collaborator,
  GetUserResponse,
  InviteTemplate,
  SubscriptionTier,
} from "../../proto/api_pb";
import { InvitedCollaborator, User } from "../../proto/api_pb";
import { InvitedCollaboratorState } from "../../proto/api_pb";
import { TrackProcessorInfo } from "../../proto/api_pb";
import { RpcError } from "grpc-web";
import { postTrackBatch, sendInvites } from "../../services/trackService";
import { emailRegex } from "../constants";
import { useNavigate } from "react-router-dom";
import { getBpm } from "../../utils/bpmUtil";
import { newTrack } from "./types";
import { UploadArtWork } from "../BatchTrackModalComponents/UplodArtWork";
import { BatchTrackModalDetails } from "../BatchTrackModalComponents/BatchTrackDetails";
import { BatchTrackModalCollabDetails } from "../BatchTrackModalComponents/BatchTrackCollabDetails";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { isBillingRequired } from "../../utils/subscriptionBillingUtils";
import Mixpanel from "../../utils/mixpanel";
import { TrackAddModalColumnContainer } from "./styles";
import { TrackAddModalFormContainer } from "./styles";
import { TrackAddModalMainContainer, batchTrackAddModalStyles } from "./styles";
import { APP_COLOR, BORDER_COLOR } from "../../theme";
import { enterpriseName, isEnterprise } from "../../theme";
import { getUser } from "../../services/userService";
import { handleUpdateFreeTierMetadata } from "../TracksPageComponents/helper";
const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;
const TRACK_VALIDATION_SCHEMA = Yup.object().shape({
  hasSong: Yup.boolean().required("Need to upload songs").oneOf([true]),
});

const BatchTrackAddModal: React.FC<BatchTrackAddModalProps> = ({
  setIsUploading,
  setUploadingFilesDetailsList,
  setUploadingCardsStatusList,
  isModalOpen,
  handleCloseBatchTrackAddModal,
  handleOpenMessageModal,
  setIsUploadProcessing,
  setFolderUploadInfo,
}) => {
  const { getValidAccessToken } = useGetValidAccessToken();
  const [collaborators, setCollaborators] = useState<Array<Collaborator>>([]);
  const [genres, setGenres] = useState<Array<string>>([]);
  const [moods, setMoods] = useState<Array<string>>([]);
  const [collabVal, setCollabVal] = useState("");
  const [usersList, setUsersList] = useState<Array<User>>([]);
  const [previewUrl, setPreviewUrl] = useState("");
  const [currentUpload, setCurrentUpload] = useState("");
  const [showCollabTooltip, setShowCollabTooltip] = useState(false);
  const [addedCollabIds, setAddedCollabIds] = useState<string[]>([]);
  const [emailInviteList, setEmailInviteList] = useState<string[]>([]);
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const {
    userName,
    storageUsage,
    subscriptionTier,
    allUsers,
    enterprise,
    isEnterpriseAccount,
  } = useContext<UserDetailsContextInterface>(UserDetailsContext);
  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken } =
    useContext<S3CredentialsContextInterface>(S3CredentialsContext);
  const [files, setFiles] = useState<any[]>([]);
  const [emailInvite, setEmailInvite] = useState("");
  const navigate = useNavigate();
  const [totalBatches, setTotalBatches] = useState(0);
  const MAX_PARALLEL_UPLOADS = 10;

  const handleFileRemove = (fileToRemove: string) => {
    const updatedFiles = files.filter((file) => file.uid !== fileToRemove);
    setFiles(updatedFiles);
  };

  useEffect(() => {
    const isNavigating = isBillingRequired(subscriptionTier, storageUsage);
    if (isNavigating && !isEnterpriseAccount) navigate("/billing");
    const userL = allUsers.filter((user) => user.getUsername() !== userName);
    setUsersList(userL);
  }, [
    allUsers,
    userName,
    navigate,
    storageUsage,
    subscriptionTier,
    isEnterpriseAccount,
  ]);

  const handleShowCollabTooltip = () => {
    setShowCollabTooltip((prev) => !prev);
  };

  const handleFile = (file: any) => {
    const normalizedFileName = file.name.replace(/[^\w\s.-]/g, "_");
    const normalizedFile = new File([file], normalizedFileName, {
      type: file.type,
    });

    setPreviewUrl(URL.createObjectURL(normalizedFile));
    URL.revokeObjectURL(previewUrl);
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const resetFiles = () => {
    setPreviewUrl("");
  };

  const handleCoverArtUploadProgress = (pNum: number, idx: number) => {};

  const handleProgress = (pNum: number, idx: number, filesList: any[]) => {
    filesList[idx].uploadProgress = Math.floor(pNum);
    const modifiedList = [...filesList];
    setUploadingFilesDetailsList(modifiedList);
  };

  // Process a single batch of files
  const processFileBatch = async (
    fileBatch: File[],
    filesList: any[],
    values: any,
    coverArtUrl: string,
    batchIndex: number,
    token: string
  ) => {
    // setBatchProgress(batchIndex + 1);

    // Upload this batch of files to S3
    const songKeys: string[] = [];
    const startIdx = batchIndex * MAX_PARALLEL_UPLOADS;

    const uploadPromises = fileBatch.map((file, i) =>
      awaitableUploadToS3(
        userId,
        file,
        `song`,
        file.type,
        awsAccessKeyId,
        awsSecretAccessKey,
        awsSessionToken,
        (progress) => handleProgress(progress, startIdx + i, filesList)
      )
    );

    const batchSongKeys = await Promise.all(uploadPromises);
    songKeys.push(...batchSongKeys);

    // Process the tracks from this batch
    const tracksProcessorInfoList: TrackProcessorInfo[] = [];
    for (let i = 0; i < songKeys.length; i++) {
      const songUrl = ASSETS_URL + "/" + songKeys[i];
      const fileIndex = startIdx + i;
      const newTrack = new TrackProcessorInfo();
      newTrack.setFilename(files[fileIndex].name);
      newTrack.setTrackUrl(songUrl);
      let bpm = 0;
      try {
        bpm = await getBpm(files[fileIndex]);
      } catch (error) {
        console.log("BPM detection Error Batch Upload");
        bpm = 0;
      }
      newTrack.setBpm(bpm);
      tracksProcessorInfoList.push(newTrack);
    }

    // Create invited collaborator list (only needed for the first batch)
    const invitedCollabList: InvitedCollaborator[] = [];
    if (batchIndex === 0) {
      emailInviteList.forEach((email) => {
        const newInvitedCollab = new InvitedCollaborator();
        newInvitedCollab.setEmail(email);
        newInvitedCollab.setInvitedCollaboratorState(
          InvitedCollaboratorState.INVITED_COLLABORATOR_STATE_PENDING
        );
        invitedCollabList.push(newInvitedCollab);
      });
    }

    // Post this batch of tracks
    const postBatchTrackResponse = await postTrackBatch(
      tracksProcessorInfoList,
      values.artist,
      values.album,
      collaborators,
      batchIndex === 0 ? invitedCollabList : [],
      userId,
      coverArtUrl,
      genres[0],
      moods[0],
      token,
      isEnterpriseAccount ? enterprise?.id : undefined
    );

    if (postBatchTrackResponse instanceof RpcError) {
      throw postBatchTrackResponse;
    }

    // Only send invites after the first batch
    if (
      batchIndex === 0 &&
      (emailInviteList.length !== 0 || addedCollabIds.length !== 0)
    ) {
      try {
        await sendInvites(
          token,
          emailInviteList,
          addedCollabIds,
          userId,
          `${window.location.origin}/my-tracks`,
          "Tracks",
          InviteTemplate.INVITE_TEMPLATE_COLLABORATE_TRACK
        );
      } catch (error) {
        console.log(error);
        alert(error);
        throw error;
      }
    }

    if (
      !isEnterpriseAccount &&
      subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_FREE
    ) {
      const user = await getUser(userId, token);
      if (user instanceof GetUserResponse) {
        const uploadedTracksCount =
          user.getFreeTierMetadata()?.getTracksUploadedForFreeMastering() ??
          0 + tracksProcessorInfoList.length;
        await handleUpdateFreeTierMetadata({
          userId,
          token,
          awsAccessKeyId,
          awsSecretAccessKey,
          awsSessionToken,
          masteringCount: user.getFreeTierMetadata()?.getMasteringCount() ?? 0,
          tracksUploaded: uploadedTracksCount,
          user,
        });
      }
    }

    // Track the successful batch upload
    Mixpanel.track("batch_track_upload_success", {
      count: tracksProcessorInfoList.length,
      batchNumber: batchIndex + 1,
      totalBatches: totalBatches,
    });

    return tracksProcessorInfoList.length;
  };

  const onSubmit = async (
    values: any,
    {
      resetForm,
      setSubmitting,
    }: {
      resetForm: any;
      setSubmitting: any;
    }
  ) => {
    setIsUploadProcessing(true);
    const normalizedFiles = files.map((file) => {
      const normalizedFileName = file.name.replace(/[^\w\s.-]/g, "_");
      return new File([file], normalizedFileName, { type: file.type });
    });

    const filesList = normalizedFiles.map((file) => ({
      file,
      name: file.name,
      uploadProgress: 0,
      isCardOpen: true,
    }));
    setUploadingFilesDetailsList(filesList);
    setUploadingCardsStatusList(
      normalizedFiles.map((file) => ({
        name: file.name,
        isCardClosed: false,
      }))
    );
    try {
      setSubmitting(true);
      handleCloseBatchTrackAddModal();
      setIsUploading(true);
      let coverArtUrl = previewUrl;
      if (values.coverArtUpload !== undefined) {
        setCurrentUpload("Image");
        const coverArtKey = await awaitableUploadToS3(
          userId,
          values.coverArtUpload,
          `cover-art`,
          values.coverArtUpload!.type,
          awsAccessKeyId,
          awsSecretAccessKey,
          awsSessionToken,
          (progress) => handleCoverArtUploadProgress(progress, 0)
        );
        coverArtUrl = ASSETS_URL + "/" + coverArtKey;
      }

      // Create batches of files
      const chunkedFileGroups = [];
      for (let i = 0; i < normalizedFiles.length; i += MAX_PARALLEL_UPLOADS) {
        chunkedFileGroups.push(
          normalizedFiles.slice(i, i + MAX_PARALLEL_UPLOADS)
        );
      }
      setTotalBatches(chunkedFileGroups.length);

      const token = await getValidAccessToken();

      // Process each batch sequentially (not in parallel)
      let totalProcessedTracks = 0;
      for (let i = 0; i < chunkedFileGroups.length; i++) {
        const processedCount = await processFileBatch(
          chunkedFileGroups[i],
          filesList,
          values,
          coverArtUrl,
          i,
          token
        );
        totalProcessedTracks += processedCount;
        console.log(totalProcessedTracks);
        // Update the overall progress
      }
      setIsUploadProcessing(false);
      setSubmitting(false);
      handleOpenMessageModal();
      resetForm();
      resetFiles();
      setGenres([]);
      setMoods([]);
      setCollaborators([]);
      handleOpenMessageModal();
    } catch (error) {
      console.log(error);
      alert(error);
      setSubmitting(false);
    }
  };

  const addCollaborator = (newCollaborator: string) => {
    if (newCollaborator) {
      if (
        collaborators.find(
          (collaborator) => collaborator.getUsername() === newCollaborator
        ) === undefined &&
        usersList.some((user) => user.getUsername() === newCollaborator)
      ) {
        const addedCollab = usersList.find(
          (user) => user.getUsername() === newCollaborator
        );

        if (addedCollab) {
          const newCollab = new Collaborator();
          newCollab.setUserId(addedCollab?.getUserId());
          newCollab.setUsername(addedCollab?.getUsername());
          const updatedCollaborators = [...collaborators, newCollab];

          setAddedCollabIds([...addedCollabIds, addedCollab.getUserId()]);
          setCollaborators(updatedCollaborators);
        }

        const newUserList = usersList.filter(
          (user) => user.getUsername() !== newCollaborator
        );
        setUsersList([...newUserList]);
        setCollabVal("");
      } else {
        toast.info("Username does not exist");
      }
    }
  };

  const removeCollaborator = (collaborator: Collaborator) => {
    const updatedCollaborators = collaborators.filter(
      (item) => item !== collaborator
    );
    setCollaborators(updatedCollaborators);

    // updating userIds list that is being passed in sendInvite
    const updatedUserIdList = addedCollabIds.filter(
      (item) => item !== collaborator.getUserId()
    );
    setAddedCollabIds([...updatedUserIdList]);

    const newUser = new User();
    newUser.setUsername(collaborator.getUsername());
    newUser.setUserId(collaborator.getUserId());

    const newUsersList = [...usersList, newUser];
    setUsersList([...newUsersList]);
  };

  const handleChangeInvites = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => setEmailInvite(event.target.value);

  const handleCollabInvites = (event: React.SyntheticEvent<Element, Event>) => {
    if (emailInvite) {
      if (emailInvite.match(emailRegex)) {
        setEmailInviteList([...emailInviteList, emailInvite]);
        setEmailInvite("");
      } else {
        toast.info("Invalid email address!");
      }
    }
  };

  const handleRemoveEmail = (email: string) => {
    const updateEmailList = emailInviteList.filter((item) => item !== email);
    setEmailInviteList(updateEmailList);
  };

  const onFilesChange = (
    newFiles: any[],
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    newFiles.forEach((file) => {
      const normalizedFileName = file.name.replace(/[^\w\s.-]/g, "_");
      const normalizedFile = new File([file], normalizedFileName, {
        type: file.type,
      });
      (normalizedFile as any).uid = crypto.randomUUID();
      let found = false;
      for (let i = 0; i < files.length; i++) {
        if (
          normalizedFile.name === files[i].name &&
          normalizedFile.size === files[i].size
        ) {
          found = true;
          break;
        }
      }
      if (!found) {
        setFiles((prevFiles) => [...prevFiles, normalizedFile]);
        setFieldValue("hasSong", true);
      }
    });
  };

  return (
    <>
      <ContainerModal
        open={isModalOpen}
        onClose={handleCloseBatchTrackAddModal}
        style={{ overflow: "auto" }}
      >
        <Box sx={styles.uploadTracksContainer}>
          <TrackAddModalFormContainer>
            <Box sx={{ padding: "15px" }}>
              <Box style={styles.modalHeaderContainer}>
                <span style={styles.modalHeader}>
                  <Box sx={styles.headerIconContainer}>
                    <img
                      style={{ filter: "invert(100%)" }}
                      src="/assets/icons/TracksPageIcons/music-note-02.svg"
                      alt="icon"
                    />
                  </Box>
                  Upload Tracks
                  <Box
                    style={{ display: "inline" }}
                    onMouseOver={() => setShowCollabTooltip(true)}
                    onMouseLeave={() => setShowCollabTooltip(false)}
                  >
                    <LightTooltip
                      title={`Add multiple tracks to upload together. The ${
                        isEnterprise ? enterpriseName : "OmMuse"
                      } Cloud will intelligently index your music files.`}
                      placement="bottom"
                      open={showCollabTooltip}
                      onClick={handleShowCollabTooltip}
                    >
                      <IconButton disableRipple>
                        <HelpOutlineIcon
                          color="info"
                          style={{ height: 16, width: 16 }}
                        />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </span>
                <IconButton onClick={handleCloseBatchTrackAddModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <hr style={{ marginBottom: 30 }} />
              <Formik
                initialValues={newTrack}
                onSubmit={onSubmit}
                validationSchema={TRACK_VALIDATION_SCHEMA}
              >
                {({
                  values,
                  handleChange,
                  isSubmitting,
                  setFieldValue,
                  setFieldError,
                  handleBlur,
                  errors,
                  touched,
                }) => (
                  <FormikForm {...({} as any)}>
                    <TrackAddModalMainContainer>
                      <TrackAddModalColumnContainer>
                        <Files
                          className="image-upload"
                          style={{
                            ...batchTrackAddModalStyles.files,
                            ...{
                              borderColor:
                                errors.hasSong && touched.hasSong
                                  ? "red"
                                  : BORDER_COLOR,
                            },
                          }}
                          onChange={(newFiles: any) =>
                            onFilesChange(newFiles, setFieldValue)
                          }
                          multiple
                          maxFileSize={100000000}
                          minFileSize={0}
                          clickable
                          accepts={["audio/*"]}
                        >
                          <MusicVideoIcon
                            sx={batchTrackAddModalStyles.musicVideoIcon}
                          />
                          Drop files here or click to upload
                        </Files>
                        {files.length > 0 && (
                          <Button
                            disabled={files.length === 0}
                            sx={{
                              ...styles.removeAllFileButton,
                              backgroundColor:
                                files.length === 0 ? "gray" : APP_COLOR,
                            }}
                            onClick={() => {
                              setFiles([]);
                              setFieldValue("hasSong", false);
                            }}
                          >
                            Remove All Files
                          </Button>
                        )}
                        <Box sx={batchTrackAddModalStyles.mainContainer}>
                          {files.map((file) => (
                            <Box
                              key={`${file.name}-${file.size}-${Date.now()}`}
                              sx={batchTrackAddModalStyles.fileMainContainer}
                            >
                              <Box sx={batchTrackAddModalStyles.fileContainer}>
                                <Box sx={styles.extensionContainer}>
                                  {file.extension}
                                </Box>
                                <Box
                                  sx={
                                    batchTrackAddModalStyles.fileNameContainer
                                  }
                                >
                                  <Box sx={{ width: "80%" }}>{file.name}</Box>
                                  <Box>{file.sizeReadable}</Box>
                                </Box>
                              </Box>
                              <IconButton
                                sx={{ marginLeft: "10px" }}
                                onClick={() => {
                                  handleFileRemove(file.uid);
                                  if (files.length === 1) {
                                    setFieldValue("hasSong", false);
                                  }
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                            </Box>
                          ))}
                        </Box>
                        {/* <p className="input-description">
                          File type supported: MP3, WAV, OGG. Max size: 100 MB
                        </p> */}
                        <UploadArtWork
                          previewUrl={previewUrl}
                          handleBlur={handleBlur}
                          handleDragOver={handleDragOver}
                          setFieldValue={setFieldValue}
                          handleFile={handleFile}
                          isSubmitting={isSubmitting}
                        />
                      </TrackAddModalColumnContainer>
                      <TrackAddModalColumnContainer>
                        <BatchTrackModalDetails
                          values={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          isSubmitting={isSubmitting}
                          genres={genres}
                          setGenres={setGenres}
                          moods={moods}
                          setMoods={setMoods}
                          setFieldValue={setFieldValue}
                        />
                        <BatchTrackModalCollabDetails
                          showCollabTooltip={showCollabTooltip}
                          handleShowCollabTooltip={handleShowCollabTooltip}
                          setShowCollabTooltip={setShowCollabTooltip}
                          userName={userName}
                          collabVal={collabVal}
                          setCollabVal={setCollabVal}
                          setFieldValue={setFieldValue}
                          usersList={usersList}
                          collaborators={collaborators}
                          isSubmitting={isSubmitting}
                          currentUpload={currentUpload}
                          values={values}
                          removeCollaborator={removeCollaborator}
                          setFieldError={setFieldError}
                          addCollaborator={addCollaborator}
                          emailInvite={emailInvite}
                          handleChangeInvites={handleChangeInvites}
                          emailInviteList={emailInviteList}
                          handleCollabInvites={handleCollabInvites}
                          handleRemoveEmail={handleRemoveEmail}
                          handleClose={handleCloseBatchTrackAddModal}
                        />
                      </TrackAddModalColumnContainer>
                    </TrackAddModalMainContainer>
                  </FormikForm>
                )}
              </Formik>
            </Box>
          </TrackAddModalFormContainer>
        </Box>
      </ContainerModal>
    </>
  );
};

export default BatchTrackAddModal;
